import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../../../utils/axios";

const initialState = {
  data: [],
  loading: false,
  message: "",
  completed: false,
  hasError: false,
};

export const fetchAmazonVendorTimeseriesData = createAsyncThunk(
  "amazonvendor/fetchAmazonVendorTimeseriesData",
  async ({ params }) => {
    const response = await axiosInstance.request({
      url: `/amazonvendor/timeseries`,
      method: `GET`,
      params: params,
    });
    return response;
  }
);

const amazonVendorTimeseriesSlice = createSlice({
  name: "amazonvendor",
  initialState,
  reducers: {
    clearData: () => {
      return initialState;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAmazonVendorTimeseriesData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAmazonVendorTimeseriesData.fulfilled, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.data = action.payload.data;
      })
      .addCase(fetchAmazonVendorTimeseriesData.rejected, (state, action) => {
        state.loading = false;
        state.completed = true;
        state.hasError = true;
        state.message = action.error.message;
      });
  },
});

const AmazonVendorTimeseriesReducer = amazonVendorTimeseriesSlice.reducer;

export default AmazonVendorTimeseriesReducer;

export const amazonVendorTimeseriesAction = amazonVendorTimeseriesSlice.actions;
